import { Component, Input } from '@angular/core';
import { Globals } from '../../../../../globals';

/**
 * Generated class for the ComboCreatePartialTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-create-partial-title',
  templateUrl: 'combo-create-partial-title.html',
})
export class ComboCreatePartialTitlePage {

  @Input() form;

  constructor(public globals: Globals,) {

  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-title/combo-create-partial-title/combo-create-partial-title.ts